import { Injectable } from "@angular/core";
import { Http, Headers } from "@angular/http";
import { BaseService } from "../../base.service";
import { CookieService } from "ngx-cookie-service";

@Injectable()
export class SpService extends BaseService {
  constructor(http: Http, cookieService: CookieService) {
    super(http, cookieService);
    this.init("sales-presenter");
  }

  getSalesPresenters(season, region, country, isCount = false) {
    let headers = new Headers();

    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", this.getAuthToken());
    let item = {
      season: season,
      region: region,
      country: country
    };
    if (isCount) {
      item["is_count"] = isCount;
    }

    return this.http
      .post(this.baseURL(), JSON.stringify(item), { headers: headers })
      .toPromise()
      .then(response => {
        return response.json();
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/products/sales-presenters/sp.service.ts